const siteUrl = "https://www.jetblackairport-luxury.com";
const brandName = "Jet Black Limousine";
const alternateBrandName = "Jet Black Luxury";
const phone = "+19149628444";
const displayPhone = "(914) 962-8444";
const defaultImage = `${siteUrl}/favicon.svg`;

export const geoAreaServed = [
  "Yorktown Heights",
  "Yorktown",
  "Westchester County",
  "Bedford",
  "Scarsdale",
  "White Plains",
  "Westchester County Airport",
  "HPN",
  "JFK Airport",
  "John F. Kennedy International Airport",
  "JFK",
  "LaGuardia Airport",
  "LGA",
  "Newark Liberty International Airport",
  "EWR",
  "Manhattan",
  "Queens",
  "Bronx",
  "Brooklyn",
  "New York City",
  "NYC",
  "Stewart International Airport",
  "SWF",
];

const primaryAreaServed = [
  "Yorktown Heights",
  "Yorktown",
  "Westchester County",
  "Bedford",
  "Scarsdale",
  "White Plains",
  "Westchester County Airport",
  "HPN",
  "JFK Airport",
  "LGA",
  "EWR",
];

const secondaryAreaServed = [
  "Manhattan",
  "Queens",
  "Bronx",
  "Brooklyn",
  "New York City",
  "NYC",
];

const airportServiceTypes = [
  "Yorktown Heights airport car service",
  "Westchester County airport car service",
  "HPN airport car service",
  "JFK airport car service",
  "LGA airport car service",
  "EWR airport car service",
  "black car service",
  "black SUV service",
  "airport transportation",
  "corporate transportation",
  "private chauffeur service",
];

const contactPoint = {
  "@type": "ContactPoint",
  telephone: phone,
  contactType: "reservations",
  areaServed: geoAreaServed,
  availableLanguage: ["en"],
  url: `${siteUrl}/contact`,
};

const localBusiness = {
  "@type": "LocalBusiness",
  "@id": `${siteUrl}/#localbusiness`,
  name: brandName,
  alternateName: alternateBrandName,
  url: `${siteUrl}/`,
  telephone: phone,
  priceRange: "$$",
  image: defaultImage,
  address: {
    "@type": "PostalAddress",
    streetAddress: "395 Hallocks Mill Rd",
    addressLocality: "Yorktown Heights",
    addressRegion: "NY",
    postalCode: "10598",
    addressCountry: "US",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: 41.2706,
    longitude: -73.7777,
  },
  areaServed: geoAreaServed,
  contactPoint,
  sameAs: [
    "https://reviews.birdeye.com/jet-black-limousine-170834567544871",
    "https://www.bbb.org/us/ny/yorktown-heights/profile/transportation/jet-black-limousine-0121-87164747",
  ],
};

const fleetLocalBusiness = {
  ...localBusiness,
  "@type": "LocalBusiness",
};

const organization = {
  "@type": "Organization",
  "@id": `${siteUrl}/#organization`,
  name: brandName,
  alternateName: alternateBrandName,
  url: `${siteUrl}/`,
  telephone: phone,
  logo: defaultImage,
  contactPoint,
  sameAs: localBusiness.sameAs,
};

const website = {
  "@type": "WebSite",
  "@id": `${siteUrl}/#website`,
  name: brandName,
  alternateName: alternateBrandName,
  url: `${siteUrl}/`,
  publisher: { "@id": `${siteUrl}/#organization` },
};

const makeOffer = ({ name, description, url = `${siteUrl}/booking`, areaServed = primaryAreaServed }) => ({
  "@type": "Offer",
  name,
  description,
  areaServed,
  url,
});

const makeServiceOffer = ({ name, description, url = `${siteUrl}/booking`, areaServed = primaryAreaServed }) => ({
  "@type": "Offer",
  name,
  description,
  areaServed,
  url,
});

const makeOfferCatalog = ({ id, name, itemListElement }) => ({
  "@type": "OfferCatalog",
  "@id": id,
  name,
  itemListElement,
});

const airportOfferCatalog = (id) => makeOfferCatalog({
  id,
  name: "Yorktown Heights and Westchester Airport Car Service Offers",
  itemListElement: [
    makeOffer({
      name: "Yorktown Heights to HPN Airport Car Service",
      description: "Private black car and SUV airport transportation from Yorktown Heights and Westchester County to Westchester County Airport.",
    }),
    makeOffer({
      name: "Yorktown Heights to JFK Airport Car Service",
      description: "Reserved chauffeur service from Yorktown Heights and Westchester County to John F. Kennedy International Airport.",
    }),
    makeOffer({
      name: "Yorktown Heights to LGA Airport Car Service",
      description: "Private airport car service from Yorktown Heights and Westchester County to LaGuardia Airport.",
    }),
    makeOffer({
      name: "Yorktown Heights to EWR Airport Car Service",
      description: "Black car and SUV transportation from Yorktown Heights and Westchester County to Newark Liberty International Airport.",
    }),
    makeOffer({
      name: "Westchester County Corporate Airport Transportation",
      description: "Corporate chauffeur service for Westchester County travelers to HPN, JFK, LGA and EWR.",
    }),
  ],
});

const makeBreadcrumb = ({ id, items }) => ({
  "@type": "BreadcrumbList",
  "@id": id,
  itemListElement: items.map((item, index) => ({
    "@type": "ListItem",
    position: index + 1,
    name: item.name,
    item: item.url,
  })),
});

const makeFaq = ({ id, questions }) => ({
  "@type": "FAQPage",
  "@id": id,
  mainEntity: questions.map(({ question, answer }) => ({
    "@type": "Question",
    name: question,
    acceptedAnswer: {
      "@type": "Answer",
      text: answer,
    },
  })),
});

const makeReserveAction = (name = "Book Yorktown Heights airport car service") => ({
  "@type": "ReserveAction",
  name,
  target: `${siteUrl}/booking`,
});

const makeSocial = ({ title, description, canonical, image = defaultImage }) => ({
  openGraph: {
    title,
    description,
    url: canonical,
    type: "website",
    image,
    siteName: brandName,
    locale: "en_US",
  },
  twitter: {
    card: "summary_large_image",
    title,
    description,
    url: canonical,
    image,
  },
});

const makeSeo = ({ id, title, description, keywords, canonical, image = defaultImage, jsonLd }) => ({
  id,
  title,
  description,
  keywords,
  canonical,
  robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
  areaServed: geoAreaServed,
  ...makeSocial({ title, description, canonical, image }),
  jsonLd,
});

export const homeSeo = makeSeo({
  id: "home",
  title: "Jet Black Limousine | Private Car Service in Westchester",
  description: `Jet Black Limousine provides private car service in Westchester for airport transportation, black SUV service, corporate travel and private chauffeur reservations. Call ${displayPhone}.`,
  keywords: "Yorktown Heights airport car service, Westchester County airport car service, Bedford car service, Scarsdale car service, White Plains car service, black car service NYC, HPN airport car service, JFK airport car service, LGA airport car service, EWR airport car service, black SUV service, private chauffeur Westchester County, Jet Black Limousine",
  canonical: `${siteUrl}/`,
  jsonLd: {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        "@id": `${siteUrl}/#webpage`,
        url: `${siteUrl}/`,
        name: "Jet Black Limousine Private Car Service in Westchester",
        headline: "Private Car Service in Westchester",
        description: "Private car service in Westchester with airport transportation, black SUV service, corporate travel and private chauffeur reservations from Jet Black Limousine.",
        isPartOf: { "@id": `${siteUrl}/#website` },
        about: { "@id": `${siteUrl}/#airport-car-service` },
        breadcrumb: { "@id": `${siteUrl}/#breadcrumb` },
        potentialAction: [
          makeReserveAction(),
          { "@type": "CommunicateAction", name: "Call Jet Black Limousine in Yorktown Heights", target: `tel:${phone}` },
        ],
      },
      localBusiness,
      organization,
      website,
      {
        "@type": "Service",
        "@id": `${siteUrl}/#airport-car-service`,
        name: "Yorktown Heights and Westchester Airport Car Service",
        alternateName: "Westchester County black car and airport transportation",
        description: "Westchester airport car service, black SUV service, corporate transportation and private chauffeur service from Yorktown Heights, Bedford, Scarsdale and White Plains to HPN, JFK, LGA and EWR, with Manhattan, Queens, Bronx and Brooklyn served as secondary NYC markets.",
        provider: { "@id": `${siteUrl}/#localbusiness` },
        serviceType: airportServiceTypes,
        areaServed: [...primaryAreaServed, ...secondaryAreaServed],
        url: `${siteUrl}/`,
        hasOfferCatalog: { "@id": `${siteUrl}/#airport-offers` },
        offers: makeOffer({
          name: "Book Yorktown Heights Airport Car Service",
          description: "Reserve private airport transportation from Yorktown Heights and Westchester County to HPN, JFK, LGA and EWR.",
        }),
      },
      airportOfferCatalog(`${siteUrl}/#airport-offers`),
      makeFaq({
        id: `${siteUrl}/#faq`,
        questions: [
          {
            question: "Does Jet Black Limousine provide airport car service from Yorktown Heights?",
            answer: "Yes. Jet Black Limousine provides private airport car service from Yorktown Heights and Westchester County to HPN, JFK, LGA and EWR.",
          },
          {
            question: "Which airport is closest to Yorktown Heights?",
            answer: "Westchester County Airport, also known as HPN, is the closest major airport served by Jet Black Limousine from Yorktown Heights.",
          },
          {
            question: "Can I book Westchester County car service to JFK, LGA or EWR?",
            answer: "Yes. Jet Black Limousine accepts reservations for Westchester County airport transportation to JFK, LaGuardia and Newark Liberty.",
          },
          {
            question: "Is airport transportation available 24/7?",
            answer: `Yes. Jet Black Limousine supports airport transportation reservations 24/7. Call ${displayPhone} or book online.`,
          },
        ],
      }),
      makeBreadcrumb({ id: `${siteUrl}/#breadcrumb`, items: [{ name: "Home", url: `${siteUrl}/` }] }),
    ],
  },
});

export const bookingSeo = makeSeo({
  id: "booking",
  title: "Book Westchester Airport Car Service | Jet Black Limousine",
  description: "Book or reserve Jet Black Limousine private car service for Westchester airport transportation, black SUV service and chauffeur travel.",
  keywords: "book Yorktown Heights airport car service, reserve Westchester County airport transportation, Bedford airport car service, Scarsdale airport car service, White Plains airport car service, book HPN car service, book JFK car service, book LGA car service, book EWR car service, black car service NYC",
  canonical: `${siteUrl}/booking`,
  jsonLd: {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        "@id": `${siteUrl}/booking#webpage`,
        url: `${siteUrl}/booking`,
        name: "Book Westchester Airport Car Service",
        headline: "Book Your Private Car Service",
        description: "Book or reserve private car service with Jet Black Limousine for Westchester airport transportation, black SUV service and chauffeur travel.",
        isPartOf: { "@id": `${siteUrl}/#website` },
        about: { "@id": `${siteUrl}/booking#service` },
        breadcrumb: { "@id": `${siteUrl}/booking#breadcrumb` },
        potentialAction: makeReserveAction("Reserve Yorktown Heights airport car service"),
      },
      localBusiness,
      {
        "@type": "Service",
        "@id": `${siteUrl}/booking#service`,
        name: "Yorktown Heights Airport Car Service Booking",
        alternateName: "Book Westchester County airport transportation",
        description: "Book private airport transportation, black car service, black SUV service and corporate chauffeur service from Yorktown Heights, Bedford, Scarsdale, White Plains and Westchester County to HPN, JFK, LGA, EWR and NYC.",
        provider: { "@id": `${siteUrl}/#localbusiness` },
        serviceType: ["book airport ride", ...airportServiceTypes],
        areaServed: [...primaryAreaServed, ...secondaryAreaServed],
        url: `${siteUrl}/booking`,
        hasOfferCatalog: { "@id": `${siteUrl}/booking#airport-offers` },
        offers: makeOffer({
          name: "Reserve Airport Transportation",
          description: "Book a private airport ride from Yorktown Heights or Westchester County to HPN, JFK, LGA or EWR.",
          url: `${siteUrl}/booking`,
        }),
      },
      airportOfferCatalog(`${siteUrl}/booking#airport-offers`),
      makeFaq({
        id: `${siteUrl}/booking#faq`,
        questions: [
          {
            question: "Can I reserve Yorktown Heights airport car service online?",
            answer: "Yes. Jet Black Limousine accepts online reservations for Yorktown Heights and Westchester County airport car service.",
          },
          {
            question: "Can I book service to HPN, JFK, LGA and EWR?",
            answer: "Yes. Reservations are available for HPN, JFK, LaGuardia and Newark Liberty airport transportation.",
          },
          {
            question: "Can I book an SUV or chauffeur for corporate airport travel?",
            answer: "Yes. Jet Black Limousine offers private chauffeurs, black SUVs and corporate airport transportation by reservation.",
          },
        ],
      }),
      makeBreadcrumb({
        id: `${siteUrl}/booking#breadcrumb`,
        items: [
          { name: "Home", url: `${siteUrl}/` },
          { name: "Book Yorktown Heights Airport Car Service", url: `${siteUrl}/booking` },
        ],
      }),
    ],
  },
});

export const onlineBookingSeo = makeSeo({
  id: "online-booking",
  title: "Online Booking | Jet Black Limousine Airport Car Service",
  description: `Book Jet Black Limousine online for private airport transfers, black car service and chauffeur transportation to JFK, LGA, EWR and HPN. Call ${displayPhone}.`,
  keywords: "Jet Black Limousine online booking, book private car online, airport car service reservation, book JFK car service, book LGA car service, book EWR car service, book HPN car service, Westchester black car booking, New York chauffeur reservation",
  canonical: `${siteUrl}/online-booking/`,
  image: `${siteUrl}/assets/images/online-booking-hero.png`,
  jsonLd: {
    "@context": "https://schema.org",
    "@graph": [
      localBusiness,
      organization,
      {
        "@type": "WebPage",
        "@id": `${siteUrl}/online-booking/#webpage`,
        url: `${siteUrl}/online-booking/`,
        name: "Online Booking for Jet Black Limousine",
        headline: "Book Your Private Car Online",
        description: "A reservation guide for booking Jet Black Limousine private airport transfers, black car service and professional chauffeur transportation online.",
        isPartOf: { "@id": `${siteUrl}/#website` },
        about: { "@id": `${siteUrl}/online-booking/#service` },
        breadcrumb: { "@id": `${siteUrl}/online-booking/#breadcrumb` },
        mainEntity: { "@id": `${siteUrl}/online-booking/#faq` },
        potentialAction: {
          "@type": "ReserveAction",
          name: "Book Your Ride with Jet Black Limousine",
          target: `${siteUrl}/booking`,
        },
      },
      {
        "@type": "Service",
        "@id": `${siteUrl}/online-booking/#service`,
        name: "Jet Black Limousine Online Booking",
        alternateName: "Private Airport Car Service Reservation",
        description: "Online reservation information for private airport transfers, luxury black car service and professional chauffeur transportation.",
        provider: { "@id": `${siteUrl}/#localbusiness` },
        serviceType: ["online car service booking", "airport transfer reservation", "private black car service", "chauffeur transportation"],
        areaServed: ["New York City", "Westchester County", "JFK Airport", "LGA", "EWR", "HPN"],
        url: `${siteUrl}/online-booking/`,
        offers: makeOffer({
          name: "Reserve Jet Black Limousine Transportation",
          description: "Book private transportation for airport transfers, corporate travel and chauffeur service.",
          url: `${siteUrl}/booking`,
          areaServed: ["New York City", "Westchester County", "JFK Airport", "LGA", "EWR", "HPN"],
        }),
      },
      makeFaq({
        id: `${siteUrl}/online-booking/#faq`,
        questions: [
          { question: "How far in advance should I make a reservation?", answer: "Book as early as possible for the best vehicle availability, especially for airport travel, early-morning pickups, holidays and group transportation. Same-day requests may be available by phone." },
          { question: "Can I change or cancel an existing reservation?", answer: `Yes. Contact Jet Black Limousine at ${displayPhone} as soon as your plans change so the team can review availability and any terms that apply.` },
          { question: "Do you monitor arriving flights?", answer: "Yes. Include the correct airline and flight number when booking so pickup timing can follow the latest available flight information." },
          { question: "What luggage information should I provide?", answer: "Provide the number of checked bags, carry-ons and oversized items so Jet Black Limousine can recommend an appropriate vehicle." },
          { question: "Can I reserve a round trip?", answer: "Yes. Reserve each direction with its own pickup date, time and location so both trips can be confirmed accurately." },
          { question: "What payment methods do you accept?", answer: "Available payment options are shown in the secure booking experience. A valid payment method is required to complete most reservations." },
          { question: "When will I receive confirmation?", answer: "Confirmation is provided after the reservation details are submitted and accepted. Review it carefully and contact the team if anything needs correction." },
          { question: "How do I request an exact quote?", answer: `Open the booking experience and enter your trip details, or call ${displayPhone}. Exact pickup, destination, timing, vehicle and trip requirements determine the final quote.` },
        ],
      }),
      makeBreadcrumb({
        id: `${siteUrl}/online-booking/#breadcrumb`,
        items: [
          { name: "Home", url: `${siteUrl}/` },
          { name: "Online Booking", url: `${siteUrl}/online-booking/` },
        ],
      }),
    ],
  },
});

const fleetVehicleSchemaItems = [
  {
    name: "Cadillac Escalade",
    category: "Luxury SUV",
    passengers: "6 Passengers",
    luggage: "6 Suitcases",
    idealUse: "Luxury SUV service for weddings, special events, concerts, corporate guests, airport transfers and private chauffeur reservations.",
    serviceType: ["Weddings", "Special Events", "Concerts", "Airport Transportation", "Corporate Travel", "Luxury SUV"],
  },
  {
    name: "SUV / Suburban",
    category: "Private SUV",
    passengers: "4 Passengers",
    luggage: "4 Suitcases",
    idealUse: "Private SUV service for point-to-point rides, family travel, corporate movement, proms, concerts and NYC regional trips.",
    serviceType: ["Point-to-Point", "Corporate Travel", "Proms", "Concerts", "NYC & Regional Travel", "Suburban SUV"],
  },
  {
    name: "Mercedes-Benz Sprinter",
    category: "Executive Van",
    passengers: "14 Passengers",
    luggage: "14 Suitcases",
    idealUse: "Large-capacity Sprinter service for group transportation, events, wedding parties, concerts, proms and coordinated regional travel.",
    serviceType: ["Group Transportation", "Weddings", "Special Events", "Proms", "Concerts", "NYC & Regional Travel", "Sprinter"],
  },
  {
    name: "Cadillac CT5",
    category: "Executive Sedan",
    passengers: "3 Passengers",
    luggage: "3 Suitcases",
    idealUse: "Executive sedan service for corporate travel, private chauffeur requests, direct point-to-point rides and airport transportation.",
    serviceType: ["Corporate Travel", "Private Chauffeur", "Point-to-Point", "Airport Transportation", "Executive Sedan"],
  },
  {
    name: "Cadillac Escalade ESV",
    category: "Extended Luxury SUV",
    passengers: "6 Passengers",
    luggage: "6 Suitcases",
    idealUse: "Extended luxury SUV service for weddings, family travel, airport transportation, private chauffeur needs and special-event arrivals.",
    serviceType: ["Weddings", "Airport Transportation", "Private Chauffeur", "Special Events", "NYC & Regional Travel", "Luxury SUV"],
  },
  {
    name: "GMC Yukon XL Denali",
    category: "Premium Large SUV",
    passengers: "6 Passengers",
    luggage: "6 Suitcases",
    idealUse: "Premium large SUV service for corporate travel, concerts, proms, special events, airport rides and regional comfort.",
    serviceType: ["Corporate Travel", "Special Events", "Proms", "Concerts", "Airport Transportation", "NYC & Regional Travel", "Luxury SUV"],
  },
  {
    name: "Lincoln Navigator L",
    category: "Executive Luxury SUV",
    passengers: "6 Passengers",
    luggage: "6 Suitcases",
    idealUse: "Executive luxury SUV service for corporate guests, weddings, private chauffeur reservations, events and regional travel.",
    serviceType: ["Corporate Travel", "Weddings", "Private Chauffeur", "Special Events", "NYC & Regional Travel", "Luxury SUV"],
  },
  {
    name: "Mercedes-Benz Sprinter Executive",
    category: "Premium Group Van",
    passengers: "10-12 Passengers",
    luggage: "12 Suitcases",
    idealUse: "Premium group van service for corporate roadshows, wedding parties, events, concerts, proms and airport groups.",
    serviceType: ["Group Transportation", "Corporate Travel", "Weddings", "Special Events", "Proms", "Concerts", "Airport Transportation", "Sprinter"],
  },
  {
    name: "Pet-Friendly Luxury SUV",
    category: "Special Service SUV",
    passengers: "5 Passengers",
    luggage: "5 Suitcases",
    idealUse: "Pet-friendly luxury SUV service for private chauffeur rides, airport transportation, point-to-point trips and regional pet travel.",
    serviceType: ["Pet Friendly", "Private Chauffeur", "Airport Transportation", "Point-to-Point", "NYC & Regional Travel", "Luxury SUV"],
  },
];

export const fleetSeo = makeSeo({
  id: "fleet",
  title: "Westchester Luxury Fleet | Jet Black Limousine",
  description: "Explore Jet Black Limousine's luxury fleet in Yorktown Heights and Westchester: Cadillac Escalade, Suburban, Sprinter, executive sedan and pet-friendly SUV for airports, corporate travel, weddings and events.",
  keywords: "Westchester luxury fleet, Yorktown Heights luxury fleet, Cadillac Escalade car service, Suburban car service, Mercedes-Benz Sprinter service, executive sedan service, luxury SUV, wedding transportation, special events transportation, corporate travel, private chauffeur, group transportation, pet friendly SUV, airport transportation",
  canonical: `${siteUrl}/fleet`,
  jsonLd: {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "CollectionPage",
        "@id": `${siteUrl}/fleet#collectionpage`,
        url: `${siteUrl}/fleet`,
        name: "Westchester Luxury Fleet in Yorktown Heights",
        headline: "Luxury SUVs, Sedans & Sprinter Vans",
        description: "Jet Black Limousine fleet options for Yorktown Heights and Westchester County: Cadillac Escalade, Suburban, Mercedes-Benz Sprinter, executive sedan, luxury SUV and pet-friendly vehicle service for airport transportation, corporate travel, weddings, special events, private chauffeur requests and group transportation.",
        isPartOf: { "@id": `${siteUrl}/#website` },
        about: { "@id": `${siteUrl}/fleet#fleet-service` },
        mainEntity: { "@id": `${siteUrl}/fleet#vehicles` },
        breadcrumb: { "@id": `${siteUrl}/fleet#breadcrumb` },
        significantLink: [`${siteUrl}/booking`, `${siteUrl}/services`, `${siteUrl}/contact`],
        potentialAction: makeReserveAction("Book a Westchester fleet vehicle"),
      },
      fleetLocalBusiness,
      {
        "@type": "Service",
        "@id": `${siteUrl}/fleet#fleet-service`,
        name: "Westchester Luxury Fleet and Chauffeur Vehicle Service",
        alternateName: "Yorktown Heights SUV, sedan, Sprinter and pet-friendly black car fleet",
        description: "Luxury SUV, Suburban, executive sedan, Cadillac Escalade, Mercedes-Benz Sprinter, wedding, special event, corporate travel, group transportation, private chauffeur, pet-friendly and airport transportation vehicles for Yorktown Heights and Westchester County, including HPN, JFK, LGA and EWR service.",
        provider: { "@id": `${siteUrl}/#localbusiness` },
        serviceType: ["luxury SUV service", "Cadillac Escalade transportation", "Suburban service", "Mercedes-Benz Sprinter service", "executive sedan service", "airport transportation", "corporate travel", "wedding transportation", "special events transportation", "private chauffeur service", "group transportation", "pet friendly SUV service"],
        areaServed: [...primaryAreaServed, ...secondaryAreaServed],
        url: `${siteUrl}/fleet`,
        hasOfferCatalog: { "@id": `${siteUrl}/fleet#vehicle-offers` },
        potentialAction: makeReserveAction("Book this fleet vehicle"),
      },
      makeOfferCatalog({
        id: `${siteUrl}/fleet#vehicle-offers`,
        name: "Westchester Luxury Fleet Offers",
        itemListElement: [
          makeServiceOffer({ name: "Cadillac Escalade and Luxury SUV Service", description: "Cadillac Escalade, Escalade ESV, GMC Yukon XL Denali and Lincoln Navigator L service for weddings, special events, concerts, corporate travel, airport transportation and private chauffeur reservations in Yorktown Heights and Westchester County." }),
          makeServiceOffer({ name: "Suburban and Private SUV Service", description: "Suburban and private SUV service for point-to-point rides, family travel, proms, concerts, corporate movement and NYC regional travel." }),
          makeServiceOffer({ name: "Executive Sedan Service", description: "Cadillac CT5 executive sedan service for corporate travel, private chauffeur requests, airport transportation and direct point-to-point rides." }),
          makeServiceOffer({ name: "Mercedes-Benz Sprinter Group Transportation", description: "Mercedes-Benz Sprinter and Sprinter Executive service for group transportation, corporate roadshows, wedding parties, events, concerts, proms and airport groups." }),
          makeServiceOffer({ name: "Pet-Friendly Luxury SUV Service", description: "Pet-friendly luxury SUV service for private chauffeur rides, airport transportation, point-to-point trips and regional pet travel." }),
        ],
      }),
      {
        "@type": "ItemList",
        "@id": `${siteUrl}/fleet#vehicles`,
        name: "Jet Black Limousine Fleet",
        numberOfItems: fleetVehicleSchemaItems.length,
        itemListElement: fleetVehicleSchemaItems.map((vehicle, index) => ({
          "@type": "ListItem",
          position: index + 1,
          url: `${siteUrl}/fleet`,
          item: {
            "@type": "Service",
            name: `${vehicle.name} Chauffeur Fleet Option`,
            serviceType: vehicle.serviceType,
            description: vehicle.idealUse,
            provider: { "@id": `${siteUrl}/#localbusiness` },
            areaServed: [...primaryAreaServed, ...secondaryAreaServed],
            url: `${siteUrl}/fleet`,
            additionalProperty: [
              { "@type": "PropertyValue", name: "Fleet Model", value: vehicle.name },
              { "@type": "PropertyValue", name: "Category", value: vehicle.category },
              { "@type": "PropertyValue", name: "Passengers", value: vehicle.passengers },
              { "@type": "PropertyValue", name: "Luggage", value: vehicle.luggage },
              { "@type": "PropertyValue", name: "Ideal Use", value: vehicle.idealUse },
              { "@type": "PropertyValue", name: "Compatible Services", value: vehicle.serviceType.join(", ") },
            ],
            potentialAction: makeReserveAction(`Book ${vehicle.name}`),
          },
        })),
      },
      makeBreadcrumb({
        id: `${siteUrl}/fleet#breadcrumb`,
        items: [
          { name: "Home", url: `${siteUrl}/` },
          { name: "Westchester Luxury Fleet", url: `${siteUrl}/fleet` },
        ],
      }),
    ],
  },
});

export const servicesSeo = makeSeo({
  id: "services",
  title: "Westchester Transportation Services | Jet Black Limousine",
  description: "Explore Jet Black Limousine transportation services in Westchester, including airport transportation, corporate travel, private chauffeur service, events and group transportation.",
  keywords: "Westchester transportation services, Yorktown Heights airport transportation, Bedford black car service, Scarsdale black car service, White Plains airport car service, black car service NYC, HPN airport transportation, JFK car service Westchester, LGA car service Westchester, EWR car service Westchester",
  canonical: `${siteUrl}/services`,
  jsonLd: {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        "@id": `${siteUrl}/services#webpage`,
        url: `${siteUrl}/services`,
        name: "Westchester Transportation Services",
        headline: "Westchester Transportation Services",
        description: "Transportation services from Yorktown Heights, Bedford, Scarsdale, White Plains and Westchester County to HPN, JFK, LGA, EWR and NYC, including airport transportation, reliable black car service, corporate travel, weddings and special events, private chauffeur, point-to-point and group transportation.",
        isPartOf: { "@id": `${siteUrl}/#website` },
        about: { "@id": `${siteUrl}/services#transportation-services` },
        breadcrumb: { "@id": `${siteUrl}/services#breadcrumb` },
        significantLink: [`${siteUrl}/booking`, `${siteUrl}/fleet`, `${siteUrl}/contact`],
        potentialAction: makeReserveAction("Book Westchester transportation service"),
      },
      localBusiness,
      {
        "@type": "Service",
        "@id": `${siteUrl}/services#transportation-services`,
        name: "Westchester Transportation Services",
        alternateName: "Yorktown Heights airport, corporate, chauffeur and event transportation services",
        description: "Airport Transportation, Corporate Travel, Weddings and Special Events, Private Chauffeur, Point-to-Point, Group Transportation and NYC Regional Transportation in Yorktown Heights, Bedford, Scarsdale, White Plains and Westchester County, with reliable black car service in White Plains, NY and airport routes to HPN, JFK, LGA and EWR.",
        provider: { "@id": `${siteUrl}/#localbusiness` },
        serviceType: [
          "Airport Transportation",
          "Corporate Travel",
          "Corporate Transportation",
          "Weddings and Special Events",
          "Private Chauffeur Service",
          "Point-to-Point Transportation",
          "Wedding Transportation",
          "Group Transportation",
          "NYC and Regional Transportation",
          "Black SUV Service",
        ],
        areaServed: [...primaryAreaServed, ...secondaryAreaServed],
        url: `${siteUrl}/services`,
        hasOfferCatalog: { "@id": `${siteUrl}/services#service-offers` },
        potentialAction: makeReserveAction("Book transportation service"),
      },
      makeOfferCatalog({
        id: `${siteUrl}/services#service-offers`,
        name: "Jet Black Limousine Transportation Services",
        itemListElement: [
          makeOffer({ name: "Airport Transportation", description: "Airport transportation from Yorktown Heights and Westchester County to HPN, JFK, LGA and EWR." }),
          makeOffer({ name: "Corporate Travel", description: "Executive transportation and corporate airport transfers for Westchester County, Yorktown Heights and NYC schedules." }),
          makeOffer({ name: "Weddings and Special Events", description: "Luxury chauffeur transportation for Westchester weddings, special events, galas and private celebrations." }),
          makeOffer({ name: "Private Chauffeur", description: "Private chauffeur service for Westchester County, Yorktown Heights and NYC travel by schedule." }),
          makeOffer({ name: "Point-to-Point Transportation", description: "Direct private transfers from Yorktown Heights, Westchester County and surrounding NYC markets." }),
          makeOffer({ name: "Group Transportation", description: "SUV and Sprinter transportation for groups, teams, airport parties and events." }),
          makeOffer({ name: "NYC and Regional Transportation", description: "Private transportation across Manhattan, Queens, Bronx, Brooklyn, Westchester County and regional destinations." }),
        ],
      }),
      makeFaq({
        id: `${siteUrl}/services#faq`,
        questions: [
          {
            question: "Do you provide airport car service from Yorktown Heights?",
            answer: "Yes. Jet Black Limousine provides airport transportation from Yorktown Heights and Westchester County to HPN, JFK, LGA and EWR.",
          },
          {
            question: "Can I book corporate travel in Westchester County?",
            answer: "Yes. Corporate Travel is available for meetings, executive airport transfers, client transportation and business schedules across Westchester County and NYC.",
          },
          {
            question: "Do you handle weddings and special events?",
            answer: "Yes. Jet Black Limousine provides luxury transportation for weddings, galas, private celebrations and special events in Westchester County and the surrounding region.",
          },
          {
            question: "Which airports do you serve from Westchester County?",
            answer: "Jet Black Limousine serves Westchester County Airport (HPN), John F. Kennedy International Airport (JFK), LaGuardia Airport (LGA) and Newark Liberty International Airport (EWR).",
          },
          {
            question: "Do you offer corporate transportation in Westchester County?",
            answer: "Yes. Corporate transportation and private chauffeur service are available for Westchester County business travel, airport transfers and regional trips.",
          },
          {
            question: "Can I book SUV or Sprinter service?",
            answer: "Yes. Black SUV, Cadillac Escalade and Mercedes-Benz Sprinter service can be reserved for airport transportation, group travel and corporate service.",
          },
          {
            question: "How do I book a transportation service?",
            answer: "Use the booking page to reserve Airport Transportation, Corporate Travel, Private Chauffeur, Point-to-Point, Group Transportation, NYC Regional Transportation or event service.",
          },
        ],
      }),
      makeBreadcrumb({
        id: `${siteUrl}/services#breadcrumb`,
        items: [
          { name: "Home", url: `${siteUrl}/` },
          { name: "Westchester Transportation Services", url: `${siteUrl}/services` },
        ],
      }),
    ],
  },
});

export const hpnSeo = makeSeo({
  id: "hpn-airport-car-service",
  title: "HPN Airport Car Service | Jet Black Limousine",
  description: "Private HPN airport car service for Westchester County travelers with professional black car and SUV transportation to and from Westchester County Airport.",
  keywords: "HPN airport car service, Westchester County black car, Westchester County Airport transportation, HPN black car service, White Plains airport car service, Yorktown Heights airport car service, private airport transportation Westchester",
  canonical: `${siteUrl}/hpn-airport-car-service/`,
  jsonLd: {
    "@context": "https://schema.org",
    "@graph": [
      localBusiness,
      {
        "@type": "Service",
        "@id": `${siteUrl}/hpn-airport-car-service/#service`,
        name: "HPN Airport Car Service",
        alternateName: "Westchester County Airport Black Car Service",
        description: "Private black car and SUV service to and from Westchester County Airport (HPN) for Westchester County, Yorktown Heights, White Plains, Bedford and Scarsdale travelers.",
        provider: { "@id": `${siteUrl}/#localbusiness` },
        serviceType: [
          "HPN airport car service",
          "Westchester County Airport transportation",
          "Westchester County black car service",
          "private airport transportation",
          "black SUV service",
        ],
        areaServed: [
          "Westchester County Airport",
          "HPN",
          "Westchester County",
          "Yorktown Heights",
          "White Plains",
          "Bedford",
          "Scarsdale",
        ],
        url: `${siteUrl}/hpn-airport-car-service/`,
        offers: makeOffer({
          name: "Book HPN Airport Car Service",
          description: "Reserve private black car and SUV transportation to or from Westchester County Airport (HPN).",
          url: `${siteUrl}/booking`,
          areaServed: ["Westchester County Airport", "HPN", "Westchester County"],
        }),
        potentialAction: makeReserveAction("Book HPN airport car service"),
      },
      makeBreadcrumb({
        id: `${siteUrl}/hpn-airport-car-service/#breadcrumb`,
        items: [
          { name: "Home", url: `${siteUrl}/` },
          { name: "Services", url: `${siteUrl}/services` },
          { name: "HPN Airport Car Service", url: `${siteUrl}/hpn-airport-car-service/` },
        ],
      }),
    ],
  },
});

export const westchesterAirportSeo = makeSeo({
  id: "westchester-airport-car-service",
  title: "Westchester Airport Car Service | Jet Black Limousine",
  description: "Professional Westchester airport car service with private black car and SUV transportation to JFK, LGA, EWR, HPN and SWF.",
  keywords: "Westchester airport car service, Westchester County airport transportation, JFK car service Westchester, LGA car service Westchester, EWR car service Westchester, HPN airport car service, SWF airport car service, black car service Westchester",
  canonical: `${siteUrl}/westchester-airport-car-service/`,
  jsonLd: {
    "@context": "https://schema.org",
    "@graph": [
      localBusiness,
      {
        "@type": "Service",
        "@id": `${siteUrl}/westchester-airport-car-service/#service`,
        name: "Westchester Airport Car Service",
        description: "Private black car and SUV airport transportation across Westchester County to JFK, LGA, EWR, HPN and SWF.",
        provider: { "@id": `${siteUrl}/#localbusiness` },
        serviceType: [
          "Westchester airport car service",
          "Westchester County airport transportation",
          "black car service",
          "private airport transportation",
          "black SUV service",
        ],
        areaServed: [...primaryAreaServed, ...secondaryAreaServed, "Stewart International Airport", "SWF"],
        url: `${siteUrl}/westchester-airport-car-service/`,
        offers: makeOffer({
          name: "Book Westchester Airport Car Service",
          description: "Reserve private airport transportation in Westchester County to JFK, LGA, EWR, HPN or SWF.",
          url: `${siteUrl}/booking`,
        }),
        potentialAction: makeReserveAction("Book Westchester airport car service"),
      },
      makeBreadcrumb({
        id: `${siteUrl}/westchester-airport-car-service/#breadcrumb`,
        items: [
          { name: "Home", url: `${siteUrl}/` },
          { name: "Services", url: `${siteUrl}/services` },
          { name: "Westchester Airport Car Service", url: `${siteUrl}/westchester-airport-car-service/` },
        ],
      }),
    ],
  },
});

export const yorktownHeightsBlackCarSeo = makeSeo({
  id: "yorktown-heights-black-car-service",
  title: "Yorktown Heights Black Car Service | Jet Black Limousine",
  description: "Yorktown Heights black car service with professional private transportation to JFK, LGA, EWR, HPN, SWF and regional destinations.",
  keywords: "Yorktown Heights black car service, Yorktown Heights airport car service, Yorktown Heights car service, Westchester County black car service, JFK car service Yorktown Heights, LGA car service Yorktown Heights, EWR car service Yorktown Heights, HPN airport car service",
  canonical: `${siteUrl}/yorktown-heights-black-car-service/`,
  jsonLd: {
    "@context": "https://schema.org",
    "@graph": [
      localBusiness,
      {
        "@type": "Service",
        "@id": `${siteUrl}/yorktown-heights-black-car-service/#service`,
        name: "Yorktown Heights Black Car Service",
        description: "Professional private black car and SUV transportation from Yorktown Heights to major airports and regional destinations.",
        provider: { "@id": `${siteUrl}/#localbusiness` },
        serviceType: [
          "Yorktown Heights black car service",
          "Yorktown Heights airport car service",
          "private airport transportation",
          "black SUV service",
          "private chauffeur service",
        ],
        areaServed: ["Yorktown Heights", "Yorktown", ...primaryAreaServed, ...secondaryAreaServed, "Putnam County", "Newark", "New Jersey"],
        url: `${siteUrl}/yorktown-heights-black-car-service/`,
        offers: makeOffer({
          name: "Book Yorktown Heights Black Car Service",
          description: "Reserve private black car and SUV transportation from Yorktown Heights to major airports and regional destinations.",
          url: `${siteUrl}/booking`,
        }),
        potentialAction: makeReserveAction("Book Yorktown Heights black car service"),
      },
      makeBreadcrumb({
        id: `${siteUrl}/yorktown-heights-black-car-service/#breadcrumb`,
        items: [
          { name: "Home", url: `${siteUrl}/` },
          { name: "Services", url: `${siteUrl}/services` },
          { name: "Yorktown Heights Black Car Service", url: `${siteUrl}/yorktown-heights-black-car-service/` },
        ],
      }),
    ],
  },
});

export const manhattanPrivateCarSeo = makeSeo({
  id: "manhattan-private-car-service",
  title: "Manhattan Private Car Service | Jet Black Limousine",
  description: `Private car service in Manhattan for airport transfers, corporate travel, hourly service, special events and premium city transportation. Call ${displayPhone}.`,
  keywords: "Manhattan private car service, private car service in Manhattan, Manhattan airport car service, JFK car service Manhattan, LGA car service Manhattan, EWR car service Manhattan, HPN car service Manhattan, SWF airport car service, Manhattan chauffeur service, Jet Black Limousine",
  canonical: `${siteUrl}/manhattan-private-car-service/`,
  jsonLd: {
    "@context": "https://schema.org",
    "@graph": [
      localBusiness,
      {
        "@type": "Service",
        "@id": `${siteUrl}/manhattan-private-car-service/#service`,
        name: "Manhattan Private Car Service",
        alternateName: "Private Car Service in Manhattan",
        description: "Private car service in Manhattan for airport transfers to JFK, LGA, EWR, HPN and SWF, plus corporate travel, hourly chauffeur service, special events and premium city transfers.",
        provider: { "@id": `${siteUrl}/#localbusiness` },
        serviceType: [
          "Manhattan private car service",
          "private car service in Manhattan",
          "Manhattan airport car service",
          "private chauffeur service",
          "black car service",
          "airport transportation",
          "corporate transportation",
          "hourly car service",
        ],
        areaServed: ["Manhattan", "New York City", "JFK Airport", "LGA", "EWR", "HPN", "SWF", ...primaryAreaServed],
        url: `${siteUrl}/manhattan-private-car-service/`,
        hasOfferCatalog: { "@id": `${siteUrl}/manhattan-private-car-service/#offers` },
        offers: makeOffer({
          name: "Book Manhattan Private Car Service",
          description: "Reserve private car service in Manhattan for airport transfers, corporate travel and premium city transportation.",
          url: `${siteUrl}/booking`,
          areaServed: ["Manhattan", "New York City"],
        }),
        potentialAction: makeReserveAction("Book Manhattan private car service"),
      },
      makeOfferCatalog({
        id: `${siteUrl}/manhattan-private-car-service/#offers`,
        name: "Manhattan Private Car Service Offers",
        itemListElement: [
          makeOffer({ name: "Manhattan to JFK Airport Car Service", description: "Private car service from Manhattan to John F. Kennedy International Airport.", areaServed: ["Manhattan", "JFK Airport"] }),
          makeOffer({ name: "Manhattan to LGA Airport Car Service", description: "Private car service from Manhattan to LaGuardia Airport.", areaServed: ["Manhattan", "LGA"] }),
          makeOffer({ name: "Manhattan to EWR Airport Car Service", description: "Private car service from Manhattan to Newark Liberty International Airport.", areaServed: ["Manhattan", "EWR"] }),
          makeOffer({ name: "Manhattan Corporate Travel", description: "Professional private transportation for business travel and corporate schedules in Manhattan.", areaServed: ["Manhattan", "New York City"] }),
        ],
      }),
      makeBreadcrumb({
        id: `${siteUrl}/manhattan-private-car-service/#breadcrumb`,
        items: [
          { name: "Home", url: `${siteUrl}/` },
          { name: "Services", url: `${siteUrl}/services` },
          { name: "Manhattan Private Car Service", url: `${siteUrl}/manhattan-private-car-service/` },
        ],
      }),
    ],
  },
});

export const newYorkTransportationSeo = makeSeo({
  id: "jet-black-transportation",
  title: "Jet Black Transportation | NYC & Westchester Car Service",
  description: `Book Jet Black Limousine for New York transportation, airport transfers, private black car, corporate travel and 24/7 chauffeur service. Call ${displayPhone}.`,
  keywords: "New York transportation, New York airport car service, NYC black car service, JFK airport transportation, LGA airport transportation, EWR airport transportation, HPN airport transportation, Westchester car service, private chauffeur New York, Jet Black Limousine",
  canonical: `${siteUrl}/jet-black-transportation/`,
  image: `${siteUrl}/assets/images/new-york-transportation-hero.png`,
  jsonLd: {
    "@context": "https://schema.org",
    "@graph": [
      localBusiness,
      organization,
      {
        "@type": "WebPage",
        "@id": `${siteUrl}/jet-black-transportation/#webpage`,
        url: `${siteUrl}/jet-black-transportation/`,
        name: "Jet Black Transportation in New York",
        headline: "Jet Black Transportation in New York",
        description: "Private black car, airport transfer, corporate travel and chauffeur transportation throughout New York City, Westchester and surrounding areas from Jet Black Limousine.",
        isPartOf: { "@id": `${siteUrl}/#website` },
        about: { "@id": `${siteUrl}/jet-black-transportation/#service` },
        breadcrumb: { "@id": `${siteUrl}/jet-black-transportation/#breadcrumb` },
        potentialAction: makeReserveAction("Book New York transportation"),
      },
      {
        "@type": "Service",
        "@id": `${siteUrl}/jet-black-transportation/#service`,
        name: "New York Transportation and Airport Car Service",
        alternateName: "Jet Black Transportation in New York",
        description: "Private transportation in New York for airport transfers, black car service, corporate travel, hourly chauffeur service, city-to-city trips and group transportation.",
        provider: { "@id": `${siteUrl}/#localbusiness` },
        serviceType: [
          "New York transportation",
          "airport transportation",
          "private black car service",
          "corporate transportation",
          "hourly chauffeur service",
          "city-to-city transportation",
          "group transportation",
        ],
        areaServed: ["New York City", "Manhattan", "Westchester County", "JFK Airport", "LGA", "EWR", "HPN"],
        url: `${siteUrl}/jet-black-transportation/`,
        hasOfferCatalog: { "@id": `${siteUrl}/jet-black-transportation/#offers` },
        offers: makeOffer({
          name: "Book Jet Black Limousine New York Transportation",
          description: "Reserve private New York transportation for airport, corporate, hourly and city-to-city travel.",
          url: `${siteUrl}/booking`,
          areaServed: ["New York City", "Manhattan", "Westchester County"],
        }),
      },
      makeOfferCatalog({
        id: `${siteUrl}/jet-black-transportation/#offers`,
        name: "New York Transportation Services",
        itemListElement: [
          makeOffer({ name: "JFK Airport Transportation", description: "Private transportation to and from John F. Kennedy International Airport.", areaServed: ["New York City", "JFK Airport"] }),
          makeOffer({ name: "LaGuardia Airport Transportation", description: "Private transportation to and from LaGuardia Airport.", areaServed: ["New York City", "LGA"] }),
          makeOffer({ name: "Newark Airport Transportation", description: "Private transportation to and from Newark Liberty International Airport.", areaServed: ["New York City", "EWR"] }),
          makeOffer({ name: "Westchester County Airport Transportation", description: "Private transportation to and from Westchester County Airport.", areaServed: ["Westchester County", "HPN"] }),
          makeOffer({ name: "New York Corporate Transportation", description: "Professional chauffeur transportation for meetings, business trips and corporate schedules.", areaServed: ["New York City", "Westchester County"] }),
        ],
      }),
      makeFaq({
        id: `${siteUrl}/jet-black-transportation/#faq`,
        questions: [
          { question: "Do you provide upfront airport quotes?", answer: "Yes. Jet Black Limousine provides clear, upfront quotes for airport transfers. The final quote is confirmed when you book." },
          { question: "Do you provide service to HPN?", answer: "Yes. Jet Black Limousine provides private transportation to and from Westchester County Airport throughout Westchester County and the New York area." },
          { question: "Do you monitor flights for delays?", answer: "Yes. Jet Black Limousine monitors arriving flights and coordinates pickup timing around the latest available flight information." },
          { question: "Can I book New York transportation 24/7?", answer: `Yes. Reservations are available online or by calling ${displayPhone}.` },
        ],
      }),
      makeBreadcrumb({
        id: `${siteUrl}/jet-black-transportation/#breadcrumb`,
        items: [
          { name: "Home", url: `${siteUrl}/` },
          { name: "Services", url: `${siteUrl}/services` },
          { name: "New York Transportation", url: `${siteUrl}/jet-black-transportation/` },
        ],
      }),
    ],
  },
});

export const aboutSeo = makeSeo({
  id: "about",
  title: "Jet Black Limousine of Westchester | Yorktown Heights Black Car",
  description: "Jet Black Limousine of Westchester brings local experience, professional chauffeurs and a reputation for dependable service in Yorktown Heights, Bedford, Scarsdale and White Plains, with airport car service to HPN, JFK, LGA and EWR.",
  keywords: "Jet Black Limousine of Westchester, Yorktown Heights limousine company, Yorktown Heights car service, Westchester County transportation company, Bedford car service, Scarsdale car service, White Plains car service, HPN airport car service, JFK airport car service, private chauffeur Westchester",
  canonical: `${siteUrl}/about`,
  jsonLd: {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "AboutPage",
        "@id": `${siteUrl}/about#aboutpage`,
        url: `${siteUrl}/about`,
        name: "About Jet Black Limousine of Westchester",
        description: "About Jet Black Limousine of Westchester, a Yorktown Heights transportation company with local experience, professional chauffeurs and dependable service for Bedford, Scarsdale, White Plains and Westchester County airport travel to HPN, JFK, LGA and EWR.",
        isPartOf: { "@id": `${siteUrl}/#website` },
        about: { "@id": `${siteUrl}/#localbusiness` },
        breadcrumb: { "@id": `${siteUrl}/about#breadcrumb` },
        potentialAction: [
          makeReserveAction("Book with Jet Black Limousine"),
          { "@type": "CommunicateAction", name: "Contact Jet Black Limousine", target: `tel:${phone}` },
        ],
      },
      organization,
      localBusiness,
      makeBreadcrumb({
        id: `${siteUrl}/about#breadcrumb`,
        items: [
          { name: "Home", url: `${siteUrl}/` },
          { name: "About Jet Black Limousine", url: `${siteUrl}/about` },
        ],
      }),
    ],
  },
});

export const contactSeo = makeSeo({
  id: "contact",
  title: "Contact Jet Black Limousine | Westchester Airport Car Service",
  description: `Contact Jet Black Limousine in Yorktown Heights for Westchester airport car service, luxury limo rental in Westchester, NY and black car service from Bedford, Scarsdale and White Plains to HPN, JFK, LGA and EWR. Call ${displayPhone}.`,
  keywords: "contact Jet Black Limousine, Yorktown Heights car service phone, Westchester County airport car service contact, Bedford car service, Scarsdale car service, White Plains car service, HPN car service contact, JFK car service Westchester, LGA car service Westchester, EWR car service Westchester",
  canonical: `${siteUrl}/contact`,
  jsonLd: {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "ContactPage",
        "@id": `${siteUrl}/contact#contactpage`,
        url: `${siteUrl}/contact`,
        name: "Contact Jet Black Limousine",
        description: "Contact Jet Black Limousine in Yorktown Heights for Westchester County airport car service, luxury limo rental in Westchester, NY and black car service from Bedford, Scarsdale and White Plains to HPN, JFK, LGA and EWR.",
        isPartOf: { "@id": `${siteUrl}/#website` },
        about: { "@id": `${siteUrl}/#localbusiness` },
        breadcrumb: { "@id": `${siteUrl}/contact#breadcrumb` },
        potentialAction: [
          { "@type": "CommunicateAction", name: "Call Jet Black Limousine in Yorktown Heights", target: `tel:${phone}` },
          { "@type": "CommunicateAction", name: "Text Jet Black Limousine", target: `sms:${phone}` },
          makeReserveAction("Reserve airport car service"),
        ],
      },
      localBusiness,
      {
        "@type": "ContactPoint",
        "@id": `${siteUrl}/contact#reservations`,
        telephone: phone,
        contactType: "reservations",
        areaServed: [...primaryAreaServed, ...secondaryAreaServed],
        availableLanguage: ["en"],
        url: `${siteUrl}/contact`,
      },
      makeBreadcrumb({
        id: `${siteUrl}/contact#breadcrumb`,
        items: [
          { name: "Home", url: `${siteUrl}/` },
          { name: "Contact Yorktown Heights Car Service", url: `${siteUrl}/contact` },
        ],
      }),
    ],
  },
});
